export default __webpack_public_path__ + "static/media/incorrect.0c9d57a5.png";